import styled from 'styled-components';
import { PaymentSolicitationStatus } from '../../types/enums';

interface IFlagStatusProps {
  status: PaymentSolicitationStatus;
}

export const SizeTeste = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 20px;
  gap: 10px;

  @media (min-width: 901px) and (max-width: 990px) {
    flex-direction: column;
  }
`;

export const SideDiv = styled.div`
  flex: 1 1 20%;
  height: 400px;
  min-width: 200px;
  background-color: #f0f0f0;
  padding: 10px;

  @media (min-width: 901px) and (max-width: 990px) {
    flex: 1 1 100%;
    min-width: unset;
    height: auto;
  }
`;

export const MainDiv = styled.div`
  flex: 1 1 60%;
  height: 400px;
  min-width: 400px;
  background-color: #e0e0e0;
  padding: 10px;

  @media (min-width: 901px) and (max-width: 990px) {
    flex: 1 1 100%;
    min-width: unset;
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    min-width: unset;
    width: 100%;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin: 1em auto;
`;

export const ResponsiveContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
`;

export const Body = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  max-height: 10%;

  gap: 1rem;

  @media (min-width: 901px) and (max-width: 990px) {
    flex: 1 1 100%;
    min-width: unset;
    width: 100%;
    height: auto;
    flex-direction: column;
  }

  @media (max-width: 1500px) {
    gap: 0.5rem;
    max-width: 100%;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    max-width: 100%;
    align-items: center;
    margin: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  margin: 20px;
  gap: 10px;
  max-width: 100vw;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin: 0;
  }

  .titlePage {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 5rem;
    max-width: 95%;

    @media (max-width: 990px) {
      padding: 0;
    }

    h1 {
      margin: 1rem 0;
      font-size: 1.5rem;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
  .containerTable {
    background: ${({ theme }) => theme.colors.background};
    border-radius: 15px;
    padding: 0.5rem 2rem;
    max-width: 90%;

    .containerExtractReport {
      display: flex;
      justify-content: flex-end;
      margin: 0.375rem 0;
    }

    @media (max-width: 500px) {
      padding: 1rem 1rem;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .containerActions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 0 0 0 20px;

    button {
      padding-left: 0.1rem;

      .containerItens {
        justify-content: flex-start;
      }
    }

    .action {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.tertiary_500};
      border: none;
      white-space: nowrap;

      svg {
        padding: 0.5rem 0.5rem 0.5rem 0;
      }

      transition: opacity 0.2s;
      text-decoration: none;

      &:hover {
        opacity: 0.85;
      }

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  .containerFilter {
    width: 100%;
  }

  @media (max-width: 850px) {
    flex-direction: column;
    align-items: self-start;

    .containerActions {
      padding: 0;
    }
  }

  @media (max-width: 580px) {
    .containerActions {
      flex-wrap: wrap;
      justify-content: left;
    }

    .MuiFormControl-root {
      width: max-content;
    }
  }
`;

export const Content = styled.div`
  .tableFixHead {
    max-height: 90vh;
    overflow-x: auto;
    overflow-y: auto;
    flex: 1 1 60%;
    padding: 10px;
    margin-right: -10px;

    .MuiTable-stickyHeader {
      padding: 0.5rem;
    }

    table {
      @media (max-width: 1700px) {
        margin-right: -25rem;
      }
      @media (max-width: 1300px) {
        margin-right: -45rem;
      }

      th {
        font-size: 1.1rem;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.blue};

        p {
          display: flex;
          align-items: center;

          svg {
            fill: ${({ theme }) => theme.colors.blue};
          }
        }
      }

      tbody {
        overflow-y: scroll;
        td {
          font-size: 1.1rem;
          font-weight: 300;
          color: ${({ theme }) => theme.colors.text};
          border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
          min-width: 7rem;

          p {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
  .containerReaminingDays {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 6rem;
  }
`;

export const FlagStatus = styled.div<IFlagStatusProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 10px;
  height: 18px;
  border-radius: 45%;
  background-color: ${({ status, theme }) =>
    status === PaymentSolicitationStatus.PAID ? 'tertiary' : theme.colors.error};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    h2 {
      color: ${({ theme }) => theme.colors.secondary};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
      width: 20px;
      height: 20px;
    }
  }

  .close-modal {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.primary};
    gap: 0.3rem;
    cursor: pointer;
    background-color: transparent;
    border: none;
    font-size: 1rem;

    svg {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  padding-top: 2rem;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.5rem;

  .button {
    font-size: 1.1rem;
  }
`;
